import React from "react";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import useCancelSubscription from "./useCancelSubscription";

const CancelSubscription = ({ subscription, handleClose, refetch }) => {
  const { formik, isCancelling, getFieldError } = useCancelSubscription(
    subscription,
    handleClose,
    refetch
  );

  return (
    <div>
      <h5 className="pro-ttl pro-mb-2">Cancel {subscription?.plan_name}</h5>
      <p className="pro-font-sm pro-mb-2">
        {subscription?.subscription_code} — {subscription?.remaining_items} of{" "}
        {subscription?.total_items} items left.
      </p>

      {/* Ends somebody's plan and may refund their money - name them before the button. */}
      <div className="pro-p-3 pro-mb-4 pro-bg-light rounded-3">
        <span className="pro-font-sm">Cancelling for</span>
        <p className="pro-mb-0 pro-fw-medium">
          {subscription?.customer_name ?? "Unnamed customer"}
          {subscription?.customer_mobile
            ? ` · ${subscription.customer_mobile}`
            : ""}
        </p>
      </div>

      <div className="pro-check-box pro-py-2 pro-mb-3">
        <input
          type="checkbox"
          className="pro-check"
          id="refund"
          name="refund"
          checked={Boolean(formik.values.refund)}
          onChange={(e) => formik.setFieldValue("refund", e?.target?.checked)}
        />
        <label htmlFor="refund" className="pro-check-label">
          Refund the customer
        </label>
      </div>

      {formik.values.refund && (
        <>
          <Input
            label={"Refund Amount (KD)"}
            type="number"
            step="0.001"
            id="refund_amount"
            name="refund_amount"
            className={`pro-input lg ${
              getFieldError("refund_amount") && " error"
            }`}
            {...formik.getFieldProps("refund_amount")}
            error={getFieldError("refund_amount")}
            errorMessage={getFieldError("refund_amount")}
          />
          {/*
            Wallet is the only tender this codebase can give back -
            OrderPaymentService::createFund() is a stub - so there is no card option to offer.
          */}
          <p className="pro-font-xs pro-mb-4">
            Defaults to the unredeemed balance at the prices frozen onto this
            subscription. Refunds go to the customer's wallet; there is no card
            refund. If the refund fails the subscription is not cancelled.
          </p>
        </>
      )}

      <div className="input-wrap pro-mb-4">
        <label htmlFor="reason" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Reason
        </label>
        <textarea
          id="reason"
          name="reason"
          rows={3}
          className={`pro-input lg ${getFieldError("reason") && " error"}`}
          {...formik.getFieldProps("reason")}
        />
        {getFieldError("reason") && (
          <span className="error-text">{getFieldError("reason")}</span>
        )}
      </div>

      <div className="pro-d-flex pro-justify-end">
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
          Back
        </Button>
        <Button
          className={`pro-btn-primary lg pro-ms-3`}
          type="submit"
          onClick={formik.handleSubmit}
          disabled={isCancelling}
        >
          {isCancelling ? "Cancelling..." : "Cancel Subscription"}
        </Button>
      </div>
    </div>
  );
};

export default CancelSubscription;
